import {
  IsNumber,
  IsOptional,
  IsString,
  IsArray,
  IsBoolean
} from 'class-validator';
import {
  PaymentDonationDto,
  PaymentReferenceType,
  MerchantDto,
  BankSource
} from '@up/data';
export class StripePaymentRequestDto {
  paymentReferenceType?: PaymentReferenceType;

  @IsNumber()
  @IsOptional()
  amount?: number;

  @IsNumber()
  @IsOptional()
  processingFee?: number;

  @IsNumber()
  @IsOptional()
  merchantId?: number;

  @IsString()
  @IsOptional()
  idempotencyKey?: string;

  @IsString()
  @IsOptional()
  paymentIntentId?: string;

  @IsOptional()
  @IsNumber()
  paymentMethodId?: number;

  @IsOptional()
  @IsNumber()
  merchantPaymentMethodId?: number;

  @IsString()
  @IsOptional()
  currency?: string;

  @IsString()
  @IsOptional()
  description?: string;

  @IsString()
  @IsOptional()
  stripeConnectAccountId?: string;

  @IsString()
  @IsOptional()
  source?: BankSource;

  @IsString()
  @IsOptional()
  clientSecret?: string;

  @IsString()
  @IsOptional()
  status?: string;

  @IsArray()
  @IsOptional()
  paymentMethodTypes?: string[];

  @IsString()
  @IsOptional()
  captureMethod?: string;

  @IsNumber()
  @IsOptional()
  orderId?: number;

  @IsNumber()
  @IsOptional()
  customerId?: number;

  @IsString()
  @IsOptional()
  notificationUrl?: string;

  @IsOptional()
  notificationData?: any;

  @IsOptional()
  paymentDonations?: PaymentDonationDto[];

  @IsBoolean()
  @IsOptional()
  storeCard?: boolean;

  @IsString()
  @IsOptional()
  paymentMethod?: string;

  @IsString()
  @IsOptional()
  customer?: string;

  @IsString()
  @IsOptional()
  name?: string;

  @IsString()
  @IsOptional()
  firstName?: string;

  @IsString()
  @IsOptional()
  lastName?: string;

  @IsString()
  @IsOptional()
  email?: string;

  @IsNumber()
  @IsOptional()
  userId?: number;

  @IsOptional()
  merchant?: MerchantDto;

  @IsOptional()
  metadata?: any;

  @IsString()
  @IsOptional()
  reason?: 'duplicate' | 'fraudulent' | 'requested_by_customer';

  @IsString()
  @IsOptional()
  digitalWalletToken?: string;

  @IsBoolean()
  @IsOptional()
  digitalWalletProcessed?: boolean;

  @IsBoolean()
  @IsOptional()
  softCancel?: boolean;

  @IsString()
  @IsOptional()
  product?: 'giftcard' | 'corporate' | 'topup' | 'INVOICING' | 'DEPOSIT' | 'BILLING' | undefined;

  @IsNumber()
  @IsOptional()
  baseAmount?: number;

  @IsNumber()
  @IsOptional()
  totalCards?: number;
}
